// Szuflada nawigacji na telefonie - arkusz wysuwany od dolu, ten sam wzorzec
// co szuflada koszyka (nakladka, panel, uchwyt, blokada przewijania tla).
// Dolozony jest tylko akordeon dla pozycji menu z podpozycjami.
(() => {
  class NavDrawer extends HTMLElement {
    connectedCallback() {
      if (this.gotowy) return;
      this.gotowy = true;
      this.zablokowane = false;
      this.podepnij();
      this.podepnijGlobalne();
      this.podepnijPrzeciaganieUchwytu();
      this.podepnijProgDesktopu();
    }

    podepnij() {
      this.addEventListener('click', (zdarzenie) => {
        if (zdarzenie.target.closest('[data-nav-drawer-close]')) {
          zdarzenie.preventDefault();
          this.zamknij();
          return;
        }

        const przelacznik = zdarzenie.target.closest('[data-nav-drawer-toggle]');
        if (przelacznik) {
          zdarzenie.preventDefault();
          this.przelaczPozycje(przelacznik);
          return;
        }

        /* Przelaczenie trybu zakupu ZOSTAWIA szuflade otwarta: w trybie
           firmowym pokazuje sie w niej panel logowania B2B (Figma 1050:8571),
           a zamkniecie okna wygladalo, jakby przelacznik wyrzucal z menu.
           Sam tryb zapisuje mode-switch.js, widocznosc panelu robi CSS. */
        const pokazHaslo = zdarzenie.target.closest('[data-b2b-password-toggle]');
        if (pokazHaslo) {
          zdarzenie.preventDefault();
          this.przelaczHaslo(pokazHaslo);
        }
      });

      /* Jezyk i region przeladowuja strone (formularz lokalizacji Shopify).
         Bez tego szuflada wisi na ekranie przez cale przeladowanie i wyglada,
         jakby wybor nic nie zrobil. */
      this.addEventListener('change', (zdarzenie) => {
        if (zdarzenie.target.matches('select[name="locale_code"], select[name="country_code"]')) {
          this.zamknij();
        }
      });
    }

    podepnijGlobalne() {
      document.addEventListener('click', (zdarzenie) => {
        const wyzwalacz = zdarzenie.target.closest('[data-nav-toggle]');
        if (!wyzwalacz) return;
        zdarzenie.preventDefault();
        if (this.hidden) {
          this.otworz();
        } else {
          this.zamknij();
        }
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });
    }

    /* Powyzej 990 px szuflade chowa arkusz stylow, wiec bez tego skrypt nigdy
       by sie nie dowiedzial, ze jest zamknieta - i blokada przewijania strony
       zostawalaby na desktopie. Ten sam bezpiecznik ma arkusz filtrow kolekcji. */
    podepnijProgDesktopu() {
      const desktop = window.matchMedia('(min-width: 990px)');
      desktop.addEventListener('change', (zdarzenie) => {
        if (zdarzenie.matches) this.zamknij();
      });
    }

    /* „Pokaz" przy haslu - ten sam przycisk przelacza typ pola i wlasny napis. */
    przelaczHaslo(przycisk) {
      const pole = this.querySelector('#nav-drawer-b2b-password');
      if (!pole) return;
      const jawne = pole.type === 'text';
      pole.type = jawne ? 'password' : 'text';
      przycisk.setAttribute('aria-pressed', String(!jawne));
      przycisk.textContent = jawne ? przycisk.dataset.pokaz : przycisk.dataset.ukryj;
    }

    przelaczPozycje(przycisk) {
      const pozycja = przycisk.closest('.nav-drawer__item');
      if (!pozycja) return;
      const otwarta = pozycja.classList.toggle('nav-drawer__item--open');
      przycisk.setAttribute('aria-expanded', String(otwarta));
    }

    otworz() {
      this.hidden = false;
      /* Podwojna klatka: przegladarka musi zdazyc policzyc stan zamkniety,
         inaczej panel pojawi sie bez animacji wysuwania. */
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('nav-drawer--open')));
      this.zablokujPrzewijanie();
      this.ustawWyzwalacze(true);
      const panel = this.querySelector('.nav-drawer__panel');
      if (panel) panel.focus();
    }

    zamknij() {
      this.classList.remove('nav-drawer--open');
      this.odblokujPrzewijanie();
      this.ustawWyzwalacze(false);
      const koniec = () => {
        this.hidden = true;
        /* Dopiero TERAZ, po zjezdzie panelu. Zdjecie klasy w trakcie animacji
           oddaje naglowkowi `will-change: transform`, czyli blok zawierajacy -
           panel przeskakiwal wtedy w gore ekranu zamiast zjechac w dol. */
        document.body.classList.remove('menu-otwarte');
      };
      const panel = this.querySelector('.nav-drawer__panel');
      if (!panel) return koniec();
      panel.addEventListener('transitionend', koniec, { once: true });
      setTimeout(koniec, 400);
    }

    /* Przeciagniecie czarnego uchwytu w dol zamyka szuflade - ten sam gest co
       na dowolnym arkuszu wysuwanym od dolu. Ponizej progu wraca na miejsce. */
    podepnijPrzeciaganieUchwytu() {
      const uchwyt = this.querySelector('.nav-drawer__handle');
      const panel = this.querySelector('.nav-drawer__panel');
      if (!uchwyt || !panel) return;

      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        if (!przeciaga) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        panel.classList.remove('nav-drawer__panel--przeciagane');
        panel.style.transform = '';
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      uchwyt.addEventListener('pointerdown', (zdarzenie) => {
        przeciaga = true;
        startY = zdarzenie.clientY;
        panel.classList.add('nav-drawer__panel--przeciagane');
        uchwyt.setPointerCapture(zdarzenie.pointerId);
      });
      uchwyt.addEventListener('pointermove', naRuch);
      uchwyt.addEventListener('pointerup', naKoniec);
      uchwyt.addEventListener('pointercancel', naKoniec);
    }

    ustawWyzwalacze(otwarte) {
      document.querySelectorAll('[data-nav-toggle]').forEach((wyzwalacz) => {
        wyzwalacz.setAttribute('aria-expanded', String(otwarte));
      });
    }

    zablokujPrzewijanie() {
      /* Szuflada siedzi W NAGLOWKU, a przyklejony naglowek ma wlasny kontekst
         ukladania (position: fixed + z-index) - bez podniesienia go karta
         zakupu i dolny pasek rysuja sie NAD otwarta szufladka. Klase zdejmuje
         odblokujPrzewijanie, arkusz stylow siedzi w sections/header.liquid. */
      document.body.classList.add('menu-otwarte');
      if (this.zablokowane) return;
      this.zablokowane = true;
      window.dizzBlokadaTla?.zablokuj(this.querySelector('.nav-drawer__panel') || this);
    }

    odblokujPrzewijanie() {
      if (!this.zablokowane) return;
      this.zablokowane = false;
      window.dizzBlokadaTla?.odblokuj();
    }
  }

  if (!customElements.get('nav-drawer')) {
    customElements.define('nav-drawer', NavDrawer);
  }
})();
